//* 组件库
import type { UiTooltipFunction } from "various-ui";
//* 组件属性
import type { ModuleFormData } from "../../../src/types";
import { CanvasDispose } from "./dispose";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    //* 静态数据
    const vars: { example?: CanvasDispose } = {};
    //* 响应式属性
    const refs = {
        data: ref<ModuleFormData>(),
        view: CanvasDispose.tips.data,
    };

    //* 节点
    const nodes = {
        tips: shallowRef<InstanceType<typeof UiTooltipFunction>>(),
        canvas: shallowRef<HTMLDivElement>(),
    };

    //* 函数列表
    const methods = {
        render: (data: ModuleFormData, option?: { update: boolean }) => {
            //* 数据缓存
            refs.data.value = data;
            //* 数据获取
            const transcript = refs.data.value?.transcripts?.find((v) => v.value == refs.data.value?.transcript);
            nextTick(() => {
                if (transcript && nodes.canvas.value?.clientWidth) {
                    //* 数据初始化
                    const is_update_gene_info = data.id == vars.example?.origin.id || data.transcript == vars.example?.origin.transcript;

                    /** @name 复合检验
                     * * 1. 实例不存在时直接绘制
                     * * 2. 实例需绘制预测位点时重新绘制
                     * * 3. 实例的基因 or 转录本发生变化时重新绘制
                     */
                    if (!vars.example || option?.update || data.data.range || (!data.data.range && is_update_gene_info)) {
                        vars.example = new CanvasDispose(data, { i18n, transcript });
                        if (nodes.canvas.value) {
                            vars.example?.render(nodes.canvas.value, nodes.tips.value);
                        }
                    }
                }
            });
        },
    };

    return { refs, nodes, methods };
};
